<div class="stt-container d-flex align-items-center">
    <button type="button" (click)="!recording ? startRecording() : stopRecording()"
        [disabled]="loading ||dictationStatus ==='processing'"
        [title]="dictationStatus ==='processing' ? 'Processing...' : (!recording ? 'Start Recording' : 'Stop Recording')"
        [class.btn-primary]="showLabel && !recording" [class.btn-danger]="showLabel && recording"
        [class.bg-primary]="!showLabel && !recording" [class.bg-danger]="!showLabel && recording"
        [class.stt-icon-button]="!showLabel" [class.stt-detection-button]="!showLabel && isDectation"
        [class.stt-small-button]="!showLabel && !isDectation" [attr.id]="recording ? 'stopRecording' : 'startRecording'"
        class="stt-button text-white d-flex align-items-center justify-content-center">

        @if(dictationStatus ==='processing'){
        @if (showLabel) {
        <span class="full-label me-2">Processing...</span>
        <span class="short-label me-2">Processing...</span>
        }

        <mat-progress-spinner class="stt-loader" [diameter]="16" mode="indeterminate" aria-label="Processing recording">
        </mat-progress-spinner>
        } @else if (recording) {

        @if (showLabel) {
        <span class="full-label me-2">Stop Recording</span>
        <span class="short-label me-2">Stop</span>
        }

        <!-- Stop recording -->
        <svg class="stt-icon" viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
            <circle class="stt-recording-dot" cx="12" cy="12" r="6" />
        </svg>

        } @else if (loading) {

        @if (showLabel) {
        <span class="full-label me-2">Start Recording</span>
        <span class="short-label me-2">Start</span>
        }

        <mat-progress-spinner class="stt-loader" [diameter]="16" mode="indeterminate">
        </mat-progress-spinner>

        } @else {

        @if (showLabel) {
        <span class="full-label me-2">Start Recording</span>
        <span class="short-label me-2">Start</span>
        }

        <!-- Microphone -->
        <svg class="stt-icon" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M12 15a3 3 0 0 0 3-3V6a3 3 0 1 0-6 0v6a3 3 0 0 0 3 3Z" />

            <path d="M19 11a7 7 0 0 1-14 0" />

            <path d="M12 18v4" />

            <path d="M8 22h8" />
        </svg>

        }
    </button>
</div>